import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-counter',
  templateUrl: './input-counter.component.html',
  styleUrls: ['./input-counter.component.scss'],
    providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCounterComponent),
      multi: true
    }
  ]
})
export class InputCounterComponent implements ControlValueAccessor {
  @Input() placeholder = '';
  isDisabled = false;
  value: number;

  writeValue(value: number): void {
    this.value = value;
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.valueAsNumber;
    if (Number.isNaN(this.value) || input.value === '') this.value = null;
    this.onChange(this.value);
    this.onTouched();
  }

  onChange = (value: number) => {};
  onTouched = () => {};

  increaseValue(): void {
    if (this.isDisabled) return;
    this.value = (this.value ?? 0 ) + 1;
    this.updateValue(this.value);
  } 

  decreaseValue(): void {
    if (this.isDisabled) return;
    this.value = (this.value ?? 0 ) - 1;
    this.updateValue(this.value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  updateValue(value: number){
    this.onChange(value);
    this.onTouched();
  }

}
